<div class="mobile_category_list">
  <app-category-bar (filter)="get_cat_products('')"></app-category-bar>
</div>
<div class="mainwidth" id="content">
  <div class="list-container">
    <div class="side-one">
      <app-category-bar (filter)="get_cat_products('')"></app-category-bar>
    </div>
    <div class="side-two" [ngClass]="(db.id_sub_category) ?'sub_side_three':'side-two'">
      <div *ngIf="skeleton">
        <ion-item *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10]">
          <ion-label>
            <h3>
              <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
            </h3>
            <p>
              <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
            </p>
            <p>
              <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
            </p>
          </ion-label>
        </ion-item>
      </div>
      <div *ngIf="db.view == 'grid' && searchmenuitems.length == '0'" class="container normal__grids p0">
        <div [ngClass]="{'bdrr':((index + 1 ) % 4)}" (click)="add_cart(item,db.plusCount(item.count))" class="mouse grid__item" *ngFor="let item of cat_products; let index = index;">
          <div class="image">
            <app-cached-image [src]="item.product_image" [spinner]="true"></app-cached-image>
            <img *ngIf="item.product_image" src="{{db.product_img(item.product_image)}}" defaultImage="" alt="">
            <span class="m-0" class="discount" *ngIf="item.discount_percentage">{{item.discount_percentage}}%</span>
          </div>
          <div class="description-container">
            <div class="description">
              <div>
                <p class="m-0  product__title"> <span class="product__title_span">
                    <img class="icon-img" src="assets/non-veg.png" />
                  </span>{{item.item | titlecase}}</p>
                <div class="prices">
                  <p class="m-0 s-price l-t cat-price" *ngIf="item.old_price != '0.00'"><span class="open_sans__font sans-font"></span>{{item.old_price |currency:db.currency}}</p>
                  <p class="m-0 price cat-price" *ngIf="item.price != '0.00'"><span class="open_sans__font sans-font"></span>{{item.price |currency:db.currency}}</p>
                  <p *ngIf="item.count != '0'" class="m-0 price cat-price">{{item.count}} X </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="db.view == 'grid_img' && searchmenuitems.length == '0'" class="container normal__grids p0">
        <div [ngClass]="{'bdrr':((index + 1 ) % 4)}" (click)="add_cart(item,db.plusCount(item.count))" class="mouse grid__item" *ngFor="let item of cat_products; let index = index;">
          <div class="description-container">
            <div class="description">
              <div>
                <p class="m-0  product__title"> <span class="product__title_span">
                    <img class="icon-img" src="assets/non-veg.png" />
                  </span>
                  {{item.item | titlecase}}</p>
                <div class="prices">
                  <p class="m-0 s-price l-t cat-price" *ngIf="item.old_price != '0.00'"><span class="open_sans__font sans-font"></span>{{item.old_price |currency:db.currency}}</p>
                  <p class="m-0 price cat-price" *ngIf="item.price != '0.00'"><span class="open_sans__font sans-font"></span>{{item.price |currency:db.currency}}</p>
                  <p *ngIf="item.count != '0'" class="m-0 price cat-price">{{item.count}} X </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="db.view == 'list' && searchmenuitems.length == '0'" class="p0">
        <ion-row>
          <ion-col [ngClass]="{'bdrr':((index + 1 ) % 3)}" size="4" *ngFor="let item of cat_products; let index = index;" class="list_container p0">
            <ion-item button (click)="add_cart(item,db.plusCount(item.count))" lines="none">
              <ion-thumbnail slot="start">
                <img src="{{db.product_img(item.product_image)}}" defaultImage="" alt="">
              </ion-thumbnail>
              <ion-label>
                <h3> <span class="product__title_span">
                    <img class="icon-img" src="assets/non-veg.png" />
                  </span> {{item.item | titlecase}}</h3>
                <div class="prices">
                  <p class="m-0 s-price l-t cat-price" *ngIf="item.old_price != '0.00'"><span class="open_sans__font sans-font"></span>{{item.old_price |currency:db.currency}}</p>
                  <p class="m-0 price cat-price" *ngIf="item.price != '0.00'"><span class="open_sans__font sans-font"></span>{{item.price |currency:db.currency}}</p>
                  <p *ngIf="item.count != '0'" class="m-0 price cat-price">{{item.count}} X </p>
                </div>
              </ion-label>
            </ion-item>
          </ion-col>
        </ion-row>
      </div>
      <div *ngIf="searchmenuitems.length == '0'" class="p0 product_list">
        <ion-row>
          <ion-col size="12" *ngFor="let item of cat_products; let index = index;" class="list_container p0" [id]="index+'_scroll'">
            <ion-item [class.active-parent]="active == index" button (click)="add_cart(item,db.plusCount(item.count))" lines="none">
              <ion-thumbnail slot="start">
                <img src="{{db.product_img(item.product_image)}}" defaultImage="" alt="">
              </ion-thumbnail>
              <ion-label>
                <h3> <span class="product__title_span">
                    <img class="icon-img" src="assets/non-veg.png" />
                  </span>{{item.item | titlecase}}</h3>
                <div class="prices justifyLeft">
                  <p class="m-0 s-price l-t cat-price" *ngIf="item.old_price != '0.00'"><span class="open_sans__font sans-font"></span>{{item.old_price |currency:db.currency}}</p>
                  <p class="m-0 price cat-price" *ngIf="item.price != '0.00'"><span class="open_sans__font sans-font"></span>{{item.price |currency:db.currency}}</p>
                  <p *ngIf="item.count != '0'" class="m-0 price cat-price">{{item.count}} X </p>
                </div>
              </ion-label>
            </ion-item>
          </ion-col>
        </ion-row>
      </div>
      <div *ngIf="searchmenuitems.length != '0'" class="p0">
        <ion-row>
          <ion-col size="12" *ngFor="let item of cat_products; let index = index;" class="list_container p0" [id]="index+'_scroll'">
            <ion-item [class.active-parent]="active == index" button (click)="add_cart(item,db.plusCount(item.count))" lines="none">
              <ion-thumbnail slot="start">
                <img src="{{db.product_img(item.product_image)}}" defaultImage="" alt="">
              </ion-thumbnail>
              <ion-label>
                <h3> <span class="product__title_span">
                    <img class="icon-img" src="assets/non-veg.png" />
                  </span>{{item.item | titlecase}}</h3>
                <div class="prices justifyLeft">
                  <p class="m-0 s-price l-t cat-price" *ngIf="item.old_price != '0.00'"><span class="open_sans__font sans-font"></span>{{item.old_price |currency:db.currency}}</p>
                  <p class="m-0 price cat-price" *ngIf="item.price != '0.00'"><span class="open_sans__font sans-font"></span>{{item.price |currency:db.currency}}</p>
                  <p *ngIf="item.count != '0'" class="m-0 price cat-price">{{item.count}} X </p>
                </div>
              </ion-label>
            </ion-item>
          </ion-col>
        </ion-row>
      </div>
      <div class="colcenter" *ngIf="cat_products.length == 0">
        <img src="assets/no-product-POS.svg" alt="">
      </div>
    </div>
    <div class="side-three" [ngClass]="(db.id_sub_category) ?'sub_side_three':'side-two'">
      <app-your-cart [load]="true"></app-your-cart>
    </div>
  </div>
</div>
